/**
 * Unauthorized Page (403)
 */

import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Lock as LockIcon } from "@mui/icons-material";
import { useAuthStore } from "@/store/authStore";
import { homePathForRole } from "@/utils/homePath";

export const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();

  // Determine the appropriate dashboard based on user role
  // Platform admins go to their portal and staff to today's attendance, else
  // "Go to Dashboard" would bounce them straight back here.
  const getDashboardPath = () => homePathForRole(user?.role);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        bgcolor: "background.default",
        p: 3,
      }}
    >
      <LockIcon sx={{ fontSize: 100, color: "error.main", mb: 3 }} />
      <Typography variant="h3" gutterBottom sx={{
        fontWeight: 700
      }}>
        Access Denied
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: "text.secondary",
          textAlign: "center",
          mb: 4
        }}>
        You don't have permission to access this resource.
        <br />
        Please contact your administrator if you believe this is an error.
      </Typography>
      <Box sx={{ display: "flex", gap: 2 }}>
        <Button variant="outlined" onClick={() => navigate(-1)}>
          Go Back
        </Button>
        <Button variant="contained" onClick={() => navigate(getDashboardPath())}>
          Go to Dashboard
        </Button>
      </Box>
    </Box>
  );
};
